<div class="steps">
    <ig-step *ngFor="let step of steps; let i = index"
        [step]="step"
        [steps]="steps"
        [index]="i">
    </ig-step>
</div>
